import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ReadinessService } from './readiness.service';

@Injectable({
  providedIn: 'root',
})
export class ReadinessGuard implements CanActivate {
  constructor(private readiness: ReadinessService, private router: Router) {}

  canActivate(): Observable<boolean | UrlTree> {
    return this.readiness.checkReadiness().pipe(
      map((ready) => (ready ? true : this.router.createUrlTree(['/service-unavailable'])))
    );
  }
}
